import React from 'react';
import PropTypes from 'prop-types';
import SelectComponent from 'pu-react/components/SelectComponent';

const ApertureCount = (props) => {
  const {
    label,
    name,
    required,
    tooltip,
    groupName,
    onChangeParameter,
    variants,
    parameters,
    errorMessage,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  let selected = null
  const options = { '': 'Select One' }

  if (variants && variants.length > 0) {
    variants.forEach((v) => {
      v.option_values.forEach((optionValue) => {
        const aditionalPrice = parseFloat(optionValue.aditional_price) || 0.0;
        if (optionValue.option_type_name === name) {
          options[optionValue.name] = `${optionValue.presentation}${aditionalPrice > 0 ? ` (+$${aditionalPrice})` : ''}`
        }
      })
    })
  }

  const items = Object.keys(options).map((value) => {
    return { value, text: options[value] }
  });

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={items}
      tooltip={tooltip}
      selected={parameters[name] || ''}
      groupName={groupName}
      errorMessage={errorMessage} />
  )
}

ApertureCount.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  groupName: PropTypes.string,
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
  variants: PropTypes.arrayOf(PropTypes.object).isRequired,
}

ApertureCount.defaultProps = {
  label: 'Aperture count',
  name: 'aperture_count',
  groupName: 'price_modifiers',
  required: true,
}
export default ApertureCount;
